import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/cn.js';

/**
 * A small status pill, in shadcn's shape and for the same reason `button.tsx`
 * gives: primitives live here as source, and only the ones something imports.
 * This is the second, added by EMP-006 because an employee's type and lifecycle
 * status are the two facts the Employees screen exists to show.
 */
const badgeVariants = cva(
  'inline-flex items-center rounded-[--radius] border px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        outline: 'border-border text-foreground',
        muted: 'border-transparent bg-muted text-muted-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export type BadgeProps = ComponentProps<'span'> & VariantProps<typeof badgeVariants>;

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
